import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointMd} from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const style = css`
  .article-info {
    margin: 0 0 var(--sbkCoreSpacing3xs) 0;
    font: var(--sbkFormStepsRegularSm);
  }

  .article-info__reading-time {
    &::before {
      content: '\\2022';
      margin: 0 var(--sbkCoreSpacing3xs) 0 var(--sbkCoreSpacing3xs);
    }
  }

  .article-info__additional-infos {
    display: flex;
    margin-bottom: var(--sbkCoreSpacingXl);

    @media all and (max-width: calc(${breakpointMd} - 1px)) {
      display: block;
    }

    span {
      display: flex;
      justify-content: flex-start;

      &:first-child {
        margin-right: var(--sbkCoreSizingXl);

        @media all and (max-width: calc(${breakpointMd} - 1px)) {
          margin-bottom: var(--sbkCoreSizing3xs);
        }
      }

      .label {
        margin-right: var(--sbkCoreSizing4xs);
      }

      sbk-icon {
        margin-right: var(--sbkLinkSpacing4xs);
      }
    }
  }
`;
